module.exports = __webpack_public_path__ + "static/site-logo-ceb794f98dce57aa130f0fe0f5e9ce5d.png";